import { localStorage } from '@kibt/krn-utils';

/**
 * 新增地址页埋点数据hooks
 * @returns
 */
export const AddressAddItemId = () => {
    const cacheKey = 'addressAddItemId';

    const setItem = (itemId: string[]) => {
        try {
            itemId?.length && localStorage.setItem(cacheKey, JSON.stringify(itemId.join(',')));
        } catch (error) {
            console.log('error');
        }
    };

    const getItem = async () => {
        try {
            const result = await localStorage.getItem(cacheKey);
            localStorage.removeItem(cacheKey);
            return result;
        } catch (error) {
            console.log('error');
        }
    };

    return {
        setItem,
        getItem,
    };
};
